module.exports = __webpack_public_path__ + "img/fulfillment.1a7ce9d2.svg";